import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=50fc514a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc514a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50fc514a')) {
      api.createRecord('50fc514a', component.options)
    } else {
      api.reload('50fc514a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=50fc514a&scoped=true&", function () {
      api.rerender('50fc514a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4XOS6k05ZwtH7/JS/comp/SearchFilterTokens.vue"
export default component.exports